import {apiGet} from '../../utils/api';
import {config} from '../../config/app-config';
import {loadContentForNewElements} from '../content-editor-src';
import {initDoctorModals} from '../doctor-modal/modal';

class AboutUsDoctorsLoader {
    constructor() {
        this.initialized = false;
        this.allBlocks = [];
        this.currentIndex = 0;
        this.container = null;
        this.doctorsGrid = null;
        this.loadMoreButton = null;
        this.rowNumber = 1; // для отслеживания нечетных/четных строк

        // Викликаємо init одразу
        this.init();
    }

    init() {
        // Перевіряємо, чи ми на сторінці about-us.html
        if (!window.location.pathname.match(/about-us(\.html)?$/)) {
            console.log('[AboutUsDoctorsLoader] Не страница about-us.html, пропускаем инициализацию');
            return;
        }

        this.container = document.getElementById('about-us-doctors');
        if (!this.container) {
            console.warn('[AboutUsDoctorsLoader] Doctors section not found on about-us page');
            return;
        }

        if (this.container.dataset.ssr === 'true') {
            console.log('[AboutUsDoctorsLoader] SSR content detected, skipping re-render');
            initDoctorModals();
            return;
        }

        this.loadDoctorsFromHomePage();
    }

    async loadDoctorsFromHomePage() {
        try {
            const blocks = await apiGet(`${config.api.paths.blocksByParent}/doctors-block-1`, {auth: false});

            if (!blocks || blocks.length === 0) {
                console.log('[AboutUsDoctorsLoader] No doctor blocks found');
                return;
            }

            this.allBlocks = blocks.sort((a, b) => {
                const orderA = a.order !== undefined ? parseInt(a.order, 10) : parseInt(a.id, 10);
                const orderB = b.order !== undefined ? parseInt(b.order, 10) : parseInt(b.id, 10);
                return orderA - orderB;
            });

            // Очистка контейнера
            this.container.innerHTML = '';

            // Обертка для строк
            this.doctorsGrid = document.createElement('div');
            this.doctorsGrid.className = 'about-us-doctors-grid';
            this.container.appendChild(this.doctorsGrid);

            // Кнопка "Завантажити більше"
            this.loadMoreButton = document.createElement('button');
            this.loadMoreButton.textContent = 'Завантажити більше';
            this.loadMoreButton.className = 'load-more-btn';
            this.loadMoreButton.style.cssText = `
                /* Ваші стилі */
            `;
            this.loadMoreButton.addEventListener('click', () => this.loadNextBatch());
            this.container.appendChild(this.loadMoreButton);

            // Загрузить первую порцию
            this.loadNextBatch();

        } catch (error) {
            console.error('[AboutUsDoctorsLoader] ❌ Error loading doctors:', error);
        }
    }

    loadNextBatch() {
        const rowsToLoad = 2;

        for (let i = 0; i < rowsToLoad; i++) {
            if (this.currentIndex >= this.allBlocks.length) {
                this.loadMoreButton.style.display = 'none';
                return;
            }

            const isOddRow = this.rowNumber % 2 === 1;

            if (isOddRow) {
                // Нечетная строка: 1 доктор слева + пустое место + 2 доктора справа
                this.createOddRow();
            } else {
                // Четная строка: 2 доктора по центру
                this.createEvenRow();
            }

            this.rowNumber++;
        }

        if (this.currentIndex >= this.allBlocks.length) {
            this.loadMoreButton.style.display = 'none';
        }
    }

    // Метод для применения отступов к карточке (только для even строк)
    applyCardMargins(card, isLastInRow = false) {
        if (!isLastInRow) {
            const applyResponsiveMargins = () => {
                const width = window.innerWidth;
                if (width >= 1200) {
                    card.style.marginRight = '24px';
                } else if (width >= 1024) {
                    card.style.marginRight = '12px';
                } else if (width >= 768) {
                    card.style.marginRight = '10px';
                } else {
                    card.style.marginRight = '0px';
                }
            };

            applyResponsiveMargins();
            window.addEventListener('resize', applyResponsiveMargins);
        } else {
            card.style.marginRight = '0px';
        }
    }

    // Метод для применения отступов между строками
    applyRowMargins(row) {
        const applyResponsiveRowMargins = () => {
            const width = window.innerWidth;
            if (width < 768) {
                // Для экранов до 768px - убираем отступы между строками
                row.style.setProperty('margin-bottom', '0px', 'important');
            } else if (width >= 1200) {
                row.style.setProperty('margin-bottom', '24px', 'important');
            } else if (width >= 1024) {
                row.style.setProperty('margin-bottom', '12px', 'important');
            } else if (width >= 768) {
                row.style.setProperty('margin-bottom', '10px', 'important');
            }
        };

        applyResponsiveRowMargins();
        window.addEventListener('resize', applyResponsiveRowMargins);
    }

    createOddRow() {
        const blocksForRow = this.allBlocks.slice(this.currentIndex, this.currentIndex + 3);
        if (blocksForRow.length === 0) return;

        const row = document.createElement('div');
        row.className = 'row';

        // Первый доктор слева
        if (blocksForRow.length >= 1) {
            const leftCol = document.createElement('div');
            leftCol.className = 'col-lg-3 col-md-3 col-12';
            const firstCard = this.createDoctorCard(blocksForRow[0]);
            if (firstCard) {
                leftCol.appendChild(firstCard);
                // Первая карточка - применяем отступы (не последняя)
                this.applyCardMargins(firstCard, false);
            }
            row.appendChild(leftCol);
        }

        // Пустое место
        const emptyCol = document.createElement('div');
        emptyCol.className = 'col-lg-3 col-md-3 d-none d-md-block';
        row.appendChild(emptyCol);

        // Остальные доктора справа - просто добавляем их как отдельные колонки
        for (let i = 1; i < blocksForRow.length; i++) {
            const col = document.createElement('div');
            col.className = 'col-lg-3 col-md-3 col-12';
            const card = this.createDoctorCard(blocksForRow[i]);
            if (card) {
                col.appendChild(card);
                // Проверяем, является ли это третьей карточкой (последней в нечетной строке)
                const isThirdCard = i === 2; // индекс 2 = третья карточка
                this.applyCardMargins(card, isThirdCard);
            }
            row.appendChild(col);
        }

        // Применяем отступы между строками
        this.applyRowMargins(row);

        this.doctorsGrid.appendChild(row);
        loadContentForNewElements(row.querySelectorAll('[data-content]'));
        initDoctorModals();

        this.currentIndex += blocksForRow.length;
    }

    createEvenRow() {
        const blocksForRow = this.allBlocks.slice(this.currentIndex, this.currentIndex + 2);
        if (blocksForRow.length === 0) return;

        const row = document.createElement('div');
        row.className = 'row justify-content-center';

        blocksForRow.forEach((block, index) => {
            const col = document.createElement('div');
            col.className = 'col-md-3 col-12';
            const card = this.createDoctorCard(block);
            if (card) {
                col.appendChild(card);
                // Применяем отступы (только для первой карточки, вторая - последняя)
                this.applyCardMargins(card, false);
            }
            row.appendChild(col);
        });

        // Применяем отступы между строками
        this.applyRowMargins(row);

        this.doctorsGrid.appendChild(row);
        loadContentForNewElements(row.querySelectorAll('[data-content]'));
        initDoctorModals();

        this.currentIndex += blocksForRow.length;
    }

    createDoctorCard(block) {
        const blockName = block.data_block_name || `doctor-${block.id}`;

        const card = document.createElement('div');
        card.className = 'doctor-card-about';
        card.setAttribute('data-block-name', blockName);
        if (block.id) card.setAttribute('data-block-id', block.id);

        card.innerHTML = `
            <div class="doctor-image-about">
                <img src="" alt="" data-content="${blockName}-image" data-type="image">
            </div>
            <h4 class="doctor-name-about" data-content="${blockName}-name"></h4>
            <p class="doctor-description-about" data-content="${blockName}-description" data-type="textarea"></p>
        `;

        return card;
    }
}

// Ініціалізація
const aboutUsDoctorsLoader = new AboutUsDoctorsLoader();
export {aboutUsDoctorsLoader};